import { extend, $, $$, addEvent } from './helper-functions'

export class PageHeader {
  constructor (settings, selectors, classes) {
    this.settings = extend({
      ScrollPositionForSticky: 80
    }, settings)

    this.selectors = extend({
      block: '.page-header',
      stickyPositionElement: '.page-header__sticky-position'
    }, selectors)

    this.classes = extend({
      sticky: 'page-header--sticky'
    }, classes)
  }

  init () {
    this.events()
    this.setStickyPosition()
    this.checkIfSticky()
  }

  events () {
    addEvent(window, 'resize', () => {
      this.setStickyPosition()
      this.checkIfSticky()
    })

    addEvent(window, 'scroll', () => {
      this.checkIfSticky()
    })
  }

  checkIfSticky () {
    const pageHeaders = $$(this.selectors.block)

    pageHeaders.forEach((pageHeader) => {
      if (window.pageYOffset > pageHeader.dataset.stickyPosition) {
        pageHeader.classList.add(this.classes.sticky)
      } else {
        pageHeader.classList.remove(this.classes.sticky)
      }
    })
  }

  setStickyPosition () {
    const pageHeaders = $$(this.selectors.block)

    pageHeaders.forEach((pageHeader) => {
      const stickyPositionElement = $(this.selectors.stickyPositionElement, pageHeader)
      if (pageHeader.classList.contains(this.classes.sticky)) {
        pageHeader.classList.remove(this.classes.sticky)
        pageHeader.dataset.stickyPosition = document.documentElement.scrollTop + stickyPositionElement.getBoundingClientRect().top
        pageHeader.classList.add(this.classes.sticky)
      } else {
        pageHeader.dataset.stickyPosition = document.documentElement.scrollTop + stickyPositionElement.getBoundingClientRect().top
      }
    })
  }
}

export default PageHeader
